import Vue from 'vue';
import iView from 'iview';
import VueI18n from 'vue-i18n';
import 'iview/dist/styles/iview.css';
import iviewEn from 'iview/dist/locale/en-US';
import router from './router';
import store from './store';
import App from './App.vue';

import youvrEn from './locale/en';

Vue.use(VueI18n);
Vue.use(iView);

Vue.locale = () => {};

Vue.config.productionTip = false;

/* Lang */
const messages = {
  en: Object.assign(iviewEn, youvrEn)
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
});

iView.i18n((key, value) => i18n.t(key, value));
// Utils.i18n = (key, value) => i18n.t(key, value);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
